<template>
    <section id="page-niveau" class="page-niveau page">
        <div class="page__content">
            <h1>Ik wil lesgeven in het</h1>
            <div class="container list-select">

                <div class="list-select__item row" v-for="level in levels"
                     v-bind:class="{'list-select__item--selected': level === currentLevel}"
                     @click="selectType(level)">
                    <div class="col-2-sm list-select__item-marker-column">
                        <div class="list-select__item-marker"></div>
                    </div>
                    <div class="col-10-sm list-select__item-text">
                        {{level}}
                    </div>
                </div>
                <div class="row" v-if="currentLevel && currentLevel !== 'voortgezet onderwijs'">
                    <div class="col-2-sm"></div>
                    <div class="col-10-sm">
                        <p>Mooi! Er zijn flinke tekorten in het {{currentLevel}} en dit blijft waarschijnlijk de komende jaren zo. Je bent dus hartstikke hard nodig in het onderwijs en dit vergroot de kans dat je snel een baan vindt.</p>
                    </div>
                </div>
                <div class="row" v-if="currentLevel">
                    <div class="col-2-sm"></div>
                    <div class="col-10-sm list-select__title">
                        <button class="button" v-on:click="nextHandler">Volgende</button>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<style lang="stylus">
    .page-ten-eerste .list-select
        margin-bottom 30px;

</style>
<script>
    const ScrollMagic = require('ScrollMagic');
    const TimelineMax = require('TimelineMax');
    import page from './page';

    export default {
        mixins: [page],
        data() {
            return {
                currentLevel: null,
                submitted: false,
                levels: [
                    'primair onderwijs', 'voortgezet onderwijs', 'mbo'
                ]
            }
        },
        methods: {
            selectType(level) {
                this.currentLevel = level;
                this.submitted = false;
                this.$emit('profileupdate', { key: 'onderwijsniveau', value: level });
            },
            submitHandler() {
                this.submitted = true;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// page-niveau.vue?350a255c